import { Alert } from 'shared/mui/Alert/Alert';

type Props = {
  firstName: string;
  lastName: string;
};

export const FinanceUserAlert: React.FC<Props> = ({ firstName, lastName }) => (
  <Alert severity="warning" sx={{ marginBottom: '8px' }}>
    {`Для пользователя ${firstName} ${lastName} отсутствует доступ к текущему разделу, обратитесь к руководителю вашей рабочей группы для предоставления доступа.`}
  </Alert>
);
